import React from 'react'
import './InfoBox.scss'

// A box containing informational text.
function InfoBox (props) {
  return <div className="info-box">{props.children}</div>
}

export default InfoBox
